import type { ComponentSingleStyleConfig } from "@chakra-ui/react"

import { fieldStyle } from "./input-definition"

const base = {
  ...fieldStyle,
  lineHeight: "normal",
}

export const Textarea: ComponentSingleStyleConfig = {
  variants: {
    outline: base,
    outlineWithBorder: base,
  },
  sizes: {
    md: {
      minH: "132px",
      px: "4",
      py: "3",
      fontSize: "sm",
    },
    sm: {
      minH: "88px",
      px: "3",
      py: "2",
      fontSize: "xs",
    },
  },
  defaultProps: {
    size: "md",
    variant: "outline",
  },
}
